exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:1370px){.res{height:75px!important}}@media (max-width:600px){.res{height:auto!important}}.box-aest{padding-bottom:-10%}.renewal-header-old{position:fixed;top:3.5rem;left:0;right:0;margin:inherit;z-index:1020}.renewal-header~.app-body{padding-top:7rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ff19e85","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/franchise_component/subscription-renewal/almost-expiry-announcement.vue
// module id = miRC
// module chunks = 50